// src/swRegistration.js

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(reg => {
          if (process.env.NODE_ENV === 'development') {

          }
        })
        .catch(err => {
          if (process.env.NODE_ENV === 'development') {
            console.error('[SW] registration failed:', err);
          }
        });
    });
  }
}

export function notifyLegalUpdatesMutated() {
  if (!('serviceWorker' in navigator)) return;
  if (!navigator.serviceWorker.controller) return;

  navigator.serviceWorker.controller.postMessage({
    type: 'LEGAL_UPDATES_MUTATED',
  });
}
